// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {Modulo} from "services-translation/modules/base/modulo";

import {TraduccionCmpGdprSinLogoAlternativamente} from "./sin_logo/alternativamente";
import {TraduccionCmpGdprSinLogoP1, TraduccionCmpGdprSinLogoP1Params} from "./sin_logo/p_1";
import {TraduccionCmpGdprSinLogoP2} from "./sin_logo/p_2";
import {TraduccionCmpGdprSinLogoP3, TraduccionCmpGdprSinLogoP3Params} from "./sin_logo/p_3";
import {TraduccionCmpGdprSinLogoP4} from "./sin_logo/p_4";
import {TraduccionCmpGdprSinLogoP5, TraduccionCmpGdprSinLogoP5Params} from "./sin_logo/p_5";
import {TraduccionCmpGdprSinLogoP6} from "./sin_logo/p_6";
import {TraduccionCmpGdprSinLogoSt1} from "./sin_logo/st_1";
import {TraduccionCmpGdprSinLogoSt2} from "./sin_logo/st_2";
import {TraduccionCmpGdprSinLogoSt3} from "./sin_logo/st_3";
import {TraduccionCmpGdprSinLogoSt4} from "./sin_logo/st_4";

export class TraduccionCmpGdprSinLogo extends Modulo {
    /* STATIC */
    // public static ID: string = "cmp.gdpr.sin_logo";
    // public static VERSION: Date = new Date("2024-05-07T08:08:06.479Z");
    // public static HASH: string = "2d64fcd8fb3eb8847574202db9272f17";

    private static CACHE: {[lang: string]: TraduccionCmpGdprSinLogo} = {};

    public static build(lang: IIdioma): TraduccionCmpGdprSinLogo {
        return this.CACHE[lang.idioma] ??= new this(lang);
    }

    /* INSTANCE */
    public alternativamente: string;
    public p_2: string;
    public p_4: string;
    public p_6: string;
    public st_1: string;
    public st_2: string;
    public st_3: string;
    public st_4: string;

    #p_1: TraduccionCmpGdprSinLogoP1;
    #p_3: TraduccionCmpGdprSinLogoP3;
    #p_5: TraduccionCmpGdprSinLogoP5;

    private constructor(_lang: IIdioma) {
        super(_lang);

        this.alternativamente = TraduccionCmpGdprSinLogoAlternativamente.build(this._lang).toString();
        this.#p_1 = TraduccionCmpGdprSinLogoP1.build(this._lang);
        this.p_2 = TraduccionCmpGdprSinLogoP2.build(this._lang).toString();
        this.#p_3 = TraduccionCmpGdprSinLogoP3.build(this._lang);
        this.p_4 = TraduccionCmpGdprSinLogoP4.build(this._lang).toString();
        this.#p_5 = TraduccionCmpGdprSinLogoP5.build(this._lang);
        this.p_6 = TraduccionCmpGdprSinLogoP6.build(this._lang).toString();
        this.st_1 = TraduccionCmpGdprSinLogoSt1.build(this._lang).toString();
        this.st_2 = TraduccionCmpGdprSinLogoSt2.build(this._lang).toString();
        this.st_3 = TraduccionCmpGdprSinLogoSt3.build(this._lang).toString();
        this.st_4 = TraduccionCmpGdprSinLogoSt4.build(this._lang).toString();
    }

    public p_1(params: Partial<TraduccionCmpGdprSinLogoP1Params> = {}) {
        return this.#p_1.render(params);
    }

    public p_3(params: Partial<TraduccionCmpGdprSinLogoP3Params> = {}) {
        return this.#p_3.render(params);
    }

    public p_5(params: Partial<TraduccionCmpGdprSinLogoP5Params> = {}) {
        return this.#p_5.render(params);
    }
}

export default (lang: IIdioma)=>TraduccionCmpGdprSinLogo.build(lang);
